/**
 * RemoveUserAccessComponent
 * This component is responsible for managing the removal of user access through the user profile access component.
 *
 * @author Muhammad Hamza Khan
 * @datetime December 4th, 2023
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import {
  IAccessDetail,
  IUserAccess,
} from 'src/app/user-management/user-management-interfaces';

@Component({
  selector: 'app-remove-user-access',
  templateUrl: './remove-user-access.component.html',
  styleUrls: ['./remove-user-access.component.scss'],
})
export class RemoveUserAccessComponent implements OnInit {
  @Input() commonAccessControl!: boolean;
  @Input() userAccess!: any;
  @Input() accessIds: string[] = [];
  @Input() siteTimeZone!: string;
  @Output() removeAccessEmitter = new EventEmitter<any>();
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;

  constructor() {}

  ngOnInit(): void {
    if (!this.commonAccessControl) {
      delete this.userAccess!.otherAccess;
    }
  }

  onSelectAccess(access: IAccessDetail) {
    switch (access?.type) {
      case CONSTANTS.HOME_ACCESS: {
        this.userAccess.homeAccess = this.updateAccess(
          this.userAccess.homeAccess,
          access
        );
        break;
      }
      case CONSTANTS.OTHER_ACCESS: {
        this.userAccess.otherAccess = this.updateAccess(
          this.userAccess.otherAccess,
          access
        );
        break;
      }
      case CONSTANTS.TEMPORARY_ACCESS: {
        this.userAccess.temporaryAccess = this.updateAccess(
          this.userAccess.temporaryAccess,
          access
        );
        break;
      }
      default:
        null;
    }
    this.removeAccessEmitter.emit(this.accessIds);
  }

  updateAccess(accessList: IAccessDetail[], selectedAccess: IAccessDetail) {
    return [
      ...accessList?.map((access: IAccessDetail) => {
        if (access.accessId === selectedAccess.accessId) {
          this.updateAccessIdList(access, selectedAccess);
          return { ...access, state: !access.state };
        } else {
          return { ...access };
        }
      }),
    ];
  }

  updateAccessIdList(access: IAccessDetail, selectedAccess: IAccessDetail) {
    if (access.state) {
      this.accessIds = this.accessIds.filter(
        (accessId: string) => accessId !== selectedAccess.accessId
      );
    } else {
      access.accessId && !this.accessIds?.includes(access.accessId)
        ? this.accessIds.push(access.accessId)
        : null;
    }
  }

  trackByAccessId(index: number, access: IAccessDetail): string | undefined {
    return access.accessId; // Use a unique identifier as the trackBy function
  }
}
